import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { setDataSource } from "../../redux/reducers/RepertoireReducer";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import { IMemberProductSearchResult } from "../types/IMemberProductSearchResult";
import CueSheetsPage from "../cueSheets/CueSheetsPage";
import { ICueSheetsSearchQuery } from "../types/ICueSheetsSearchQuery";
import { FormatFields } from "../../redux/types/FormatFields";
import { ICueSheetsSearchResult } from "../types/ICueSheetsSearchResult";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";

export interface IMyDraftCueSheetsPageProps {
    cueSheetsPageData?: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchCueSheets?: (query: ICueSheetsSearchQuery) => void;
    cueSheetsSearchResults?: ICueSheetsSearchResult[];
    memberSetListSearchResults?: IMemberProductSearchResult[];
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    searchSuccessful: boolean;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    currentUserNameNumber?: string;
    getCueSheetsDetails: (dataSource: string, productCoreId: number, lookupValues: ILookupDictionary, formats?: FormatFields[]) => void;
    memberPortalSearchType: MemberPortalSearchTypeItem;
    expandedProductResults: number[];
    expandAll: boolean;
    expandProductResult: (productResult: number) => void;
    expandAllResults: () => void;
}

const MyDraftCueSheetsPage = (props: IMyDraftCueSheetsPageProps) => {
    const myDraftCueSheetsPage = CueSheetsPage
    return myDraftCueSheetsPage({
        cueSheetsPageData: props.cueSheetsPageData,
        searchViewData: props.searchViewData,
        searchResultsTableData: props.searchResultsTableData,
        searchCueSheets: props.searchCueSheets,
        cueSheetsSearchResults: null,
        memberCueSheetsSearchResults: props.cueSheetsSearchResults,
        searchSuccessful: props.searchSuccessful,
        lookupValues: props.lookupValues,
        indexOfFirstResult: props.indexOfFirstResult,
        indexOfLastResult: props.indexOfLastResult,
        resultsPerPage: props.resultsPerPage,
        currentPage: props.currentPage,
        resetPagination: props.resetPagination,
        updatePagination: props.updatePagination,
        sortSearchResults: props.sortSearchResults,
        defaultActiveAccordions: props.defaultActiveAccordions,
        allResultsPerPage: props.allResultsPerPage,
        updateUserPreferences: props.updateUserPreferences,
        loadMembersPortalFromPath: props.loadMembersPortalFromPath,
        disabled: props.disabled,
        setDataSource: props.setDataSource,
        dataSource: props.dataSource,
        activeTab: props.activeTab,
        tabs: props.tabs,
        currentUserNameNumber: props.currentUserNameNumber,
        memberPortalSearchType: props.memberPortalSearchType,
        registeredCueSheetsMaintenanceGeneralDataView: undefined,
        getCueSheetsDetails: props.getCueSheetsDetails,
        expandAll: props.expandAll,
        expandProductResult: props.expandProductResult,
        expandAllResults: props.expandAllResults,
        expandedProductResults: props.expandedProductResults
    })
}

export default MyDraftCueSheetsPage;
